import React from "react";
import styles from "./BlogArticleSkeleton.module.css";

const BlogArticleSkeleton: React.FC = () => {
  return (
    <div
      className={styles.articleSkeletonContainer}
      aria-busy="true"
      aria-label="Cargando artículo del blog"
    >
      {/* Cover image skeleton */}
      <div className={styles.coverSkeleton} />

      {/* Header skeleton */}
      <div className={styles.headerSkeleton}>
        <div className={styles.categoriesContainerSkeleton}>
          <div className={styles.categorySkeleton} />
          <div className={styles.categorySkeleton} />
        </div>
        <div className={styles.titleSkeleton} />
        <div className={styles.metaSkeleton}>
          <div className={styles.readingTimeSkeleton} />
          <div className={styles.authorSkeleton}>
            <div className={styles.authorAvatarSkeleton} />
            <div className={styles.authorNameSkeleton} />
          </div>
        </div>
      </div>

      {/* Content skeleton */}
      <div className={styles.contentSkeleton}>
        {/* Paragraph blocks */}
        {Array(3)
          .fill(0)
          .map((_, index) => (
            <div key={index} className={styles.paragraphSkeleton}>
              {Array(3)
                .fill(0)
                .map((_, i) => (
                  <div
                    key={i}
                    className={styles.textLineSkeleton}
                    style={{ width: `${90 - i * 10}%` }}
                  />
                ))}
            </div>
          ))}

        {/* Image block */}
        <div className={styles.imageBlockSkeleton} />

        {/* Quote block */}
        <div className={styles.quoteBlockSkeleton}>
          <div className={styles.quoteLineSkeleton} />
          <div className={styles.quoteLineSkeleton} style={{ width: "80%" }} />
          <div className={styles.quoteCitationSkeleton} />
        </div>

        {/* Final paragraphs */}
        {Array(2)
          .fill(0)
          .map((_, index) => (
            <div key={`p2-${index}`} className={styles.paragraphSkeleton}>
              {Array(3)
                .fill(0)
                .map((_, i) => (
                  <div
                    key={i}
                    className={styles.textLineSkeleton}
                    style={{ width: `${90 - i * 10}%` }}
                  />
                ))}
            </div>
          ))}
      </div>

      {/* Related products skeleton */}
      <div className={styles.relatedProductsSkeleton}>
        <div className={styles.relatedTitleSkeleton} />
        <div className={styles.productsRowSkeleton}>
          {Array(3)
            .fill(0)
            .map((_, index) => (
              <div key={index} className={styles.productCardSkeleton}>
                <div className={styles.productImageSkeleton} />
                <div className={styles.productNameSkeleton} />
                <div className={styles.productPriceSkeleton} />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default BlogArticleSkeleton;
